var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('app-date-range-statistic-filter',{attrs:{"data-entity":"statistics"}}),_c('MonitoringTrafficNetworkFilter'),_c('button',{staticClass:"btn btn-extra-round btn-primary",on:{"click":_vm.emitFilterLoad}},[_vm._v("\n        "+_vm._s(_vm.$t("message.generics.message.fetchData"))+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }